import {Component, inject, signal} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {GenericFormComponent} from '../../../../../shared/components/generic-form/generic-form.component';
import {AuthService} from '../../../../../core/auth/auth.service';
import {RegisterData} from '../../../../../shared/model/register-data';
import {ApiResponse} from '../../../../../shared/model/api-response';
import {User} from '../../../../../shared/model/user';
import {Messages} from '../../../../../shared/constants/messages';
import {AlertService} from '../../../../../shared/services/alert.service';

@Component({
  selector: 'app-signup-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    RouterLink,
    GenericFormComponent
  ],
  templateUrl: './signup-form.component.html',
  styleUrl: './signup-form.component.css',
})
export class SignupFormComponent {

  private authService: AuthService = inject(AuthService);
  private router: Router = inject(Router);
  private fb: FormBuilder = inject(FormBuilder);
  private alertService: AlertService = inject(AlertService);

  signupForm: FormGroup = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    userName: ['', [Validators.required]],
    password: ['', [Validators.required, Validators.minLength(6)]]
  });

  isLoading = signal(false);
  errorMessage = signal<string | null>(null);

  onSubmit() {
    if (this.signupForm.invalid) {
      this.signupForm.markAllAsTouched();
      return;
    }

    this.isLoading.set(true);
    const formValues = this.signupForm.value;

    // Legge il base href dall'elemento <base> nell'HTML (es. "/app/" in produzione)
        const base = document.querySelector('base');
        const baseHref = base?.getAttribute('href') || '/';
        const contextPath = baseHref.replace(/\/+$/, '');
        const baseUrl = `${window.location.origin}${contextPath}`;

    const signupData: RegisterData = {
      email: formValues.email,
      userName: formValues.userName,
      password: formValues.password,
      userProfileRole: 'PLAYER',
      frontendBaseUrl: baseUrl
    };

    this.authService.makeSignup(signupData).subscribe({
      next: (apiResponse: ApiResponse<User>) => {
        this.isLoading.set(false);
        if (apiResponse.success && apiResponse.data) {
          this.alertService.showSuccess(Messages.REGISTRATION_CONFIRM_EMAIL);
          this.router.navigate(['/login']);
        } else {
          this.errorMessage.set(apiResponse.message || Messages.REGISTRATION_ERROR);
        }
      },
      error: () => {
        this.isLoading.set(false);
      }
    });
  }
}
